import { UserService } from "@/services";
import { util } from "@/helpers";
import { CommonClass } from "@/mixins";
import { ERROR_CODES } from "@/utils/constants";
const {
  MIDERR_001,
  MIDERR_002,
  MIDERR_003,
} = ERROR_CODES;

export default {
  async changePassword({ commit }, payload) {
    commit("SET_STATUS", 0);
    commit("SET_IS_FETCHING", true);
    try {
      const response = await UserService.changePassword(payload);
      const data = CommonClass.methods.$__processDecryptResponse(response.data, process.env.VUE_APP_ENCODEKEY);
      if (data?.successFlag) {
        commit("SET_STATUS", 1);
        commit("SET_RESPONSE", data);
        return data;
      } else {
        commit("SET_STATUS", 2);
        console.log("err", data?.errCode);
        const errMsg = util.getUiErrorByCode(data?.errCode);
        if (
          ![MIDERR_001, 
            MIDERR_002,
            MIDERR_003,
          ].includes(data?.errCode)
        ) {
          commit(
            "alert/SHOW_ALERT",
            {
              message: errMsg,
              type: "error",
            },
            { root: true }
          );
          document.getElementById("app").scrollIntoView({ behavior: "smooth" });
        }
      }
    } catch (e) {
      commit("SET_STATUS", 2);
      const respData = CommonClass.methods.$__processDecryptResponse(e.response.data, process.env.VUE_APP_ENCODEKEY);
      commit("SET_RESPONSE", respData);
      const errCode = respData?.errCode ?? e.response.status;
      const errMsg = util.getUiErrorByCode(errCode);
      if (
        ![MIDERR_001, 
          MIDERR_002,
          MIDERR_003,
        ].includes(errCode)
      ) {
        commit(
          "alert/SHOW_ALERT",
          {
            message: errMsg,
            type: "error",
          },
          { root: true }
        );
        document.getElementById("app").scrollIntoView({ behavior: "smooth" });
      }
      return respData;
    } finally {
      commit("SET_IS_FETCHING", false);
    }
  },
};
